import { UserProfileInfo as View } from 'ui-components'
import { useGetCurrentUser } from '~user-profile/queries/useGetUserById'

const ProfileInfo = () => {
  const { isLoading, data: user } = useGetCurrentUser()

  return (
    <View
      loading={isLoading}
      user={user}
    />
  )
}

export { ProfileInfo }
